import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { SelectList } from "@common/selectList";
import { ArrowIcon } from "@common/assets/arrowIcon";
import { SortOptions } from "../../types";
import { Props } from "./types";
import styles from "./styles.scss";

function SortDropdown({ selectedSort, setSelectedSort }: Props) {
  const { t } = useTranslation();
  return (
    <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
      {({ isOpen }) => ({
        input: (
          <div
            className={classNames(styles.input, { [styles.opened]: isOpen })}
          >
            <p>{t(selectedSort)}</p>
            <ArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <div className={styles.list}>
            {Object.values(SortOptions).map((option) => (
              <div
                key={option}
                className={classNames(styles.option, {
                  [styles.selected]: selectedSort === option,
                })}
                onClick={() => setSelectedSort(option)}
              >
                <p>{t(option)}</p>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { SortDropdown };
